import { useParams } from 'react-router-dom';
import {
  SidePanel,
  SidePanelType,
  ButtonPseudo,
  IconLoader,
  PermissionDenied,
  PermissionEnum,
} from '@ui/src';
import { useAppSelector } from '@store';
import { CofStatus } from '../../../common/types';
import CompanyItem from './company-item';
import useOverviewCompaniesPanel from '../hooks/use-companies-panel';

import cn from '../styles.module.css';

const OverviewCompaniesPanel = () => {
  const { activePermissions } = useAppSelector((state) => state.root);
  const { baseUserInformation } = useAppSelector(
    (state) => state.individualCustomers.info.overview,
  );

  const { customerId } = useParams();

  const { panelIsOpen, selectedTab, setSelectedTab, handleClose } =
    useOverviewCompaniesPanel({ customerId });

  let content;

  if (
    activePermissions?.includes(
      PermissionEnum.CORPORATE_CUSTOMERS_EDIT_OFFICIALS_ACTION,
    )
  ) {
    if (!baseUserInformation?.representativeOfOrganizations) {
      content = (
        <div className={cn.companyOfficialLoader}>
          <IconLoader />
        </div>
      );
    } else {
      content = (
        <>
          <div
            className={`${cn.companyOfficialTabs} ${cn.companyOfficialPanelTabs}`}
          >
            <button
              type="button"
              className={`${cn.companyOfficialTab} ${
                selectedTab === 'current' ? cn.companyOfficialTabActive : ''
              }`}
              onClick={() => setSelectedTab('current')}
            >
              Current
            </button>
            <button
              type="button"
              className={`${cn.companyOfficialTab} ${
                selectedTab === 'removed' ? cn.companyOfficialTabActive : ''
              }`}
              onClick={() => setSelectedTab('removed')}
            >
              Removed
            </button>
          </div>
          {selectedTab === 'current' &&
            baseUserInformation.representativeOfOrganizations &&
            baseUserInformation?.representativeOfOrganizations?.length > 0 &&
            baseUserInformation?.representativeOfOrganizations
              ?.filter(
                (item) =>
                  item.status !== CofStatus.ARCHIVED &&
                  item.status !== CofStatus.REJECTED,
              )

              .map((item) => (
                <CompanyItem
                  key={item.id}
                  value={item}
                  list={baseUserInformation?.representativeOfOrganizations}
                />
              ))}
          {selectedTab === 'removed' &&
            (baseUserInformation.representativeOfOrganizations &&
            baseUserInformation?.representativeOfOrganizations?.filter(
              (item) =>
                item.status === CofStatus.ARCHIVED ||
                item.status === CofStatus.REJECTED,
            )?.length > 0 ? (
              baseUserInformation?.representativeOfOrganizations
                ?.filter(
                  (item) =>
                    item.status === CofStatus.ARCHIVED ||
                    item.status === CofStatus.REJECTED,
                )
                .map((item) => (
                  <CompanyItem key={item.id} value={item} removed />
                ))
            ) : (
              <div>No removed COF yet</div>
            ))}
        </>
      );
    }
  } else {
    content = <PermissionDenied />;
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Customers}
        closeOnClickOutside
        isOpen={panelIsOpen}
        onClose={handleClose}
        title="Companies"
        sidepanelExpandedKey="customer-companies"
        footer={
          <div>
            <ButtonPseudo text="Close" onClick={handleClose} bold />
          </div>
        }
      >
        {content}
      </SidePanel>
      <div id="popup-modal" />
    </>
  );
};

export default OverviewCompaniesPanel;
